import store from '@/store';
import uuid from 'uuid/v4';

export default function addDefaultHeaders(config) {
  if (store.getters.siteId) {
    config.headers['X-SITE-ID'] = store.getters.siteId;
  }
  config.headers['X-Request-Id'] = uuid();
  return config;
}
